<div class="flex position-relative" style="width: 100%">
  <!-- <div>{{in_map_data |json}}</div> -->
  <div class="row hdrCls">
    {{ in_map_data.hdr_settings.title }}
    @if (in_map_data.keysShared && in_map_data.keysShared.length==0) {
    <span> - {{ in_map_data.hdr_settings.sb_title }}</span>
    }
  </div>
  <div class="w-full">
    <div id="{{ mapId }}" style="width: 100%; height: 60vh; z-index: 0">
      @if (in_map_data.dbrd_lvl==0) {
      <div class="segments-container">
        @if (in_map_data.keysShared && in_map_data.keysShared.length>0) {
        <div class="w-100 p-1">
          <div class="segments-div overflow-y-auto">
            @for (k of in_map_data.keysShared; track k) {
            <div>
              <div (click)="plotSlctdHeatKey(k)" class="sgmnt-cls">
                <!--   [ngClass]="{'actv_btn': k.slctd==true,'inActv_btn': k.slctd==false}" -->
                @if (k.slctd==true) {
                <span nz-icon nzType="check" nzTheme="outline">Selected:</span>
                }
                {{ k.dsply_nm }}
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      } @if (shwPopCrd==true) {
      <div class="pop-card">
        <div class="dst_nmCls">{{ data.popCrdDtls.dstrt_nm }}</div>
        <div class="infoTbl">
          <table>
            <tr>
              @for (s of tableData; track s) {
              <th>{{ s.header }}</th>
              }
              <!-- <th>Operational Plants</th>
                <th>Under Construction</th>
                <th>Work not Initiated</th> -->
            </tr>
            <tr>
              @for (s of tableData; track s) {
              <td>{{ s.value }}</td>
              }
              <!-- <td>{{slctdData.cmpltd_ct}}</td>
                <td>{{slctdData.pnd_ct}}</td>
                <td>{{slctdData.ntstrtd_ct}}</td> -->
            </tr>
          </table>
        </div>
      </div>
      } @if (in_map_data.dbrd_lvl==0 && slctdKeydata && slctdKeydata.length>0) {
      <div class="scale-crd slider-container">
        <div class="slider-line-container">
          <div
            class="slider-line"
            [ngStyle]="{ background: gradientBackground }"
            (mousemove)="onHover($event)"
            (mouseleave)="onLeave()"
          ></div>
          @if (hoveredValue !== null) {
          <div class="tooltip" [ngStyle]="{ left: tooltipPosition + 'px' }">
            <!--  -->
            {{ hoverdTitle }}: {{ hoveredValue }}
          </div>
          }
        </div>
      </div>
      } @if (in_map_data.dbrd_lvl<=1) {
      <div class="dst-nm-card">
        @if (data.dstElmtns && data.dstElmtns.length>0) {
        <table>
          <tr>
            <td>
              @for (d of data.dstElmtns.slice(0, 6); track d; let i = $index) {
              <div>
                <div
                  [ngClass]="{
                    Active_dstrct: d.shwSlctdDstrt == true,
                    Active_hvr_dstrct: d.shwHvr == true
                  }"
                >
                  {{ d.sqnce_id }}.{{ d.elmnt_nm }}
                </div>
              </div>
              }
            </td>
            <td>
              @for (d of data.dstElmtns.slice(6,12); track d; let i = $index) {
              <div>
                <div
                  [ngClass]="{
                    Active_dstrct: d.shwSlctdDstrt == true,
                    Active_hvr_dstrct: d.shwHvr == true
                  }"
                >
                  {{ d.sqnce_id }}.{{ d.elmnt_nm }}
                </div>
              </div>
              }
            </td>
            <td>
              @for (d of data.dstElmtns.slice(12,18); track d; let i = $index) {
              <div>
                <div
                  [ngClass]="{
                    Active_dstrct: d.shwSlctdDstrt == true,
                    Active_hvr_dstrct: d.shwHvr == true
                  }"
                >
                  {{ d.sqnce_id }}.{{ d.elmnt_nm }}
                </div>
              </div>
              }
            </td>
            <td>
              @for (d of data.dstElmtns.slice(18,24); track d; let i = $index) {
              <div>
                <div
                  [ngClass]="{
                    Active_dstrct: d.shwSlctdDstrt == true,
                    Active_hvr_dstrct: d.shwHvr == true
                  }"
                >
                  {{ d.sqnce_id }}.{{ d.elmnt_nm }}
                </div>
              </div>
              }
            </td>
            <td>
              @for (d of data.dstElmtns.slice(24); track d; let i = $index) {
              <div>
                <div
                  [ngClass]="{
                    Active_dstrct: d.shwSlctdDstrt == true,
                    Active_hvr_dstrct: d.shwHvr == true
                  }"
                >
                  {{ d.sqnce_id }}.{{ d.elmnt_nm }}
                </div>
              </div>
              }
            </td>
          </tr>
        </table>
        }
      </div>
      } @if (in_map_data.dbrd_lvl==2) {
      <div class="dst-nm-card">
        @if (data.ulbElmnts && data.ulbElmnts.length>0) {
        <table>
          <tr>
            <td>
              @for (d of data.ulbElmnts.slice(0,5); track d; let i = $index) {
              <div
                class="dstNm_cls"
                [ngClass]="{ Active_dstrct: d.shwSlctdULB == true }"
              >
                {{ i + 1 }}.{{ d.elmnt_nm }}
              </div>
              }
            </td>
            <td>
              @for (d of data.ulbElmnts.slice(5); track d; let i = $index) {
              <div
                class="dstNm_cls"
                [ngClass]="{ Active_dstrct: d.shwSlctdULB == true }"
              >
                {{ i + 6 }}.{{ d.elmnt_nm }}
              </div>
              }
            </td>
          </tr>
        </table>
        }
      </div>
      }
    </div>
  </div>
</div>
@if (settings.shwLdg === true) {
<ds-loading></ds-loading>
}
